// Generated from SVG to Code Figma Plugin

export const ProductLineAiVideo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.00039 4.2002H18.0004C19.3259 4.2002 20.4004 5.27471 20.4004 6.60019V17.4002C20.4004 18.7257 19.3259 19.8002 18.0004 19.8002L12.0004 19.8002H6.00039C4.67491 19.8002 3.60039 18.7257 3.60039 17.4002L3.60039 6.6002C3.60039 5.27471 4.67491 4.2002 6.00039 4.2002Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.7998 14.0786V9.92139L14.3994 11.9995L10.7998 14.0786Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);
